mutation deleteMember($id: ID) {
  deleteMember(id: $id) {
    id
  }
}
